import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { TradeTransitionArrow } from "../generic/common/TradeTransitionArrow";
import { IconWithModifier } from "../generic/icon-with-modifier/IconWithModifier";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
export var ImprovementUpgradeEffects = function (_a) {
    var item = _a.item, isLocked = _a.isLocked;
    var icon = item.icon, locaKey = item.locaKey, currentBonus = item.currentBonus, nextBonus = item.nextBonus;
    var modifierIconProps = {
        icon: IdIcon.PlusResearchIcn,
        position: IdBadgePosition.BottomLeft,
        styleId: IdStyles.IconSmall,
    };
    var nextLevelEffects = isLocked ? (React.createElement(Icon, { icon: IdIcon.LockIcn, styleId: IdStyles.IconMedium })) : (React.createElement(React.Fragment, null,
        React.createElement(IconWithModifier, { styleId: IdStyles.IconMedium, icon: icon, modifierIconProps: modifierIconProps, tooltipLoca: locaKey }),
        React.createElement(NumberFormat, { amount: nextBonus, format: TypeNumberFormat.AddIncludingZero, className: IdStyles.TextBoldSecondaryOutline })));
    return (React.createElement("div", { className: "improvement__effects" },
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement(TextLoca, { id: IdLoca.currentBonus, className: IdStyles.TextNormal }),
            React.createElement("div", { className: IdStyles.ImprovementCurrentBonusBackground + " flex flex--guts" },
                React.createElement(IconWithModifier, { styleId: IdStyles.IconMedium, icon: icon, modifierIconProps: modifierIconProps, tooltipLoca: locaKey }),
                React.createElement(NumberFormat, { amount: currentBonus, format: TypeNumberFormat.AddIncludingZero, className: IdStyles.TextPositive }))),
        React.createElement(TradeTransitionArrow, null),
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement(TextLoca, { id: IdLoca.nextUpgrade, className: IdStyles.TextNormal }),
            React.createElement("div", { className: IdStyles.ImprovementNextBonusBackground + " flex flex--guts" }, nextLevelEffects))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/ImprovementUpgradeEffects.tsx
// module id = 2694
// module chunks = 3